export function postcodeFormatter(postcode: string) {
  if (!postcode) return ""
  const trimmed = postcode.replace(/\s/g, "")
  const last = trimmed.substring(trimmed.length - 3, trimmed.length)
  const first = trimmed.substring(0, trimmed.length - 3)
  return (first + " " + last).toUpperCase()
}
